import React from 'react';
import { Box } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

import { SizingMultiplier } from '@ocx-app/theme/constants';

import { LoyaltyCurrencyIcon } from '@ocx/feat-loyalty-currency';

export type ExpirationIconBoxProps = {
  variant: 'warning' | 'normal';
};

const ICON_SIZE = 40;

export const ExpirationIconBox = ({ variant }: ExpirationIconBoxProps) => {
  const isWarning = variant === 'warning';

  return (
    <Box
      width={ICON_SIZE}
      height={ICON_SIZE}
      borderRadius={2}
      display="flex"
      alignItems="center"
      justifyContent="center"
      mr={SizingMultiplier.sm}
      bgcolor={isWarning ? 'PointExpiration.warningBackground' : 'PointExpiration.currencyBackground'}>
      {isWarning ? (
        <ErrorIcon sx={{ color: 'error.main' }} />
      ) : (
        <LoyaltyCurrencyIcon variant="multiple" size="medium" />
      )}
    </Box>
  );
};
